import React from "react";
import { PageHeader } from "../components/shared/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { DailyDeliveryTab } from "../components/reports/DailyDeliveryTab";
import { PackingListTab } from "../components/reports/PackingListTab";
import { RouteSummaryTab } from "../components/reports/RouteSummaryTab";
import { FinancialTab } from "../components/reports/FinancialTab";
import { SubscriptionsReportTab } from "../components/reports/SubscriptionsReportTab";
import { useListState } from "../hooks/useListState";

export default function Reports() {
  const [activeTab, setActiveTab] = useListState("reports.activeTab", "daily-delivery");
  return (
    <div data-testid="reports-page">
      <PageHeader title="Reports" description="Daily delivery counts, packing lists, route summaries, revenue and subscription breakdowns." />
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList data-testid="reports-tabs">
          <TabsTrigger value="daily-delivery" data-testid="reports-tab-daily-delivery">Daily Delivery</TabsTrigger>
          <TabsTrigger value="packing" data-testid="reports-tab-packing">Packing List</TabsTrigger>
          <TabsTrigger value="routes" data-testid="reports-tab-routes">Route Summary</TabsTrigger>
          <TabsTrigger value="financial" data-testid="reports-tab-financial">Financial</TabsTrigger>
          <TabsTrigger value="subscriptions" data-testid="reports-tab-subscriptions">Subscriptions</TabsTrigger>
        </TabsList>
        <TabsContent value="daily-delivery"><DailyDeliveryTab /></TabsContent>
        <TabsContent value="packing"><PackingListTab /></TabsContent>
        <TabsContent value="routes"><RouteSummaryTab /></TabsContent>
        <TabsContent value="financial"><FinancialTab /></TabsContent>
        <TabsContent value="subscriptions"><SubscriptionsReportTab /></TabsContent>
      </Tabs>
    </div>
  );
}
